import ProductListingPage from "./ProductListingPage";

export const ProductListingPageWrapper = props => (
  <ProductListingPage {...props} />
);

export default ProductListingPageWrapper;
